import { render, staticRenderFns } from "./individual_reporte_estudiante.vue?vue&type=template&id=0d2b8436"
import script from "./individual_reporte_estudiante.vue?vue&type=script&lang=js"
export * from "./individual_reporte_estudiante.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports